import ValidateFields from './ValidateFields';

window.addEventListener('load', (): void => {
    const styles = document.createElement('style');
    styles.type = 'text/css';
    styles.innerHTML = `
        .validation-error-message.hidden {
            visibility: hidden;
        }

        .validation-error-message.visible {
            visibility: visible;
        }
    `;

    document.head.appendChild(styles);

    const forms = document.querySelectorAll<HTMLFormElement>('form.validate');

    forms.forEach(form => {
        new ValidateFields(form);
    });
});